const defaultErrorParams = {
    template: '',
};

export default {
    name: 'input-error',
    template: null,

    props: {
        errorParams: {
            type: Object,
            default: () => ({}),
        },
        qaDataAttributes: {
            type: Object,
            default: () => ({}),
        },
    },
    render(h) {
        return h({
            template: `<div class="input-light-error" data-at-role="${this.qaDataAttributes.role
                || 'error_text'}">${this.params.template}</div>`,
        });
    },

    computed: {
        params() {
            return Object.assign(defaultErrorParams, this.errorParams);
        },
    },
};
